const product = {
    page_title: "商品列表",
    operator_btn1: "商品入库",
    operator_btn2: "新增商品",
    operator_btn3: "入库",
    fl_search: "输入搜索",
    fl_category: "商品分类",
    fl_brand: "商品品牌",
    fp_name_num: "商品名称/商品货号",
    fp_category: "请选择商品类别",
    fp_brand: "请选择品牌",
    tl_code: "编号",
    tl_image: "商品图片",
    tl_name: "商品名称",
    tl_price_serial: "价格/货号",
    tl_tags: "标签",
    tl_quantity: "库存",
    tl_sales: "销量",
    tr_price: "价格",
    tr_serial: "货号",
    tr_newest: "上新",
    tr_promotion: "促销",
    tr_hot: "热销",
    tr_recommend: "推荐",
    tr_quantity: "库存预警",
    dt_productPut: "商品入库",
    dl_addQuantity: "新增库存",
    dp_serial: "输入商品货号",
    db_search: "搜索",
    em_serial: "请输入正确的货号",
    em_putQuantity: "商品入库失败",
    sm_putQuantity: "商品入库成功"
};
export default product;
